import Vue from 'vue'
import VueRouter from 'vue-router'
import Page404 from '../modules/Page404/App'
import PageAuth from '../modules/PageAuth/App'
import VueLayout from '../modules/Layout/App'
import PageAdminMain from '../modules/PageAdminMain/App'
import PageOrders from '../modules/PageOrders/App'
import PageRegularDelivery from '../modules/PageRegularDelivery/App'
import PageShop from '../modules/PageShop/App'
import PagePickers from '../modules/PagePickers/App'
import PageGeo from '../modules/PageGeo/PageGeo'
import PageLocation from '../modules/PageLocations/PageLocation'
import PageArea from '../modules/PageArea/App'
import {AuthenticationService} from '../api/auth'

Vue.use(VueRouter)

const authService = new AuthenticationService()

const routes = [
  {
    path: '/not-found',
    name: 'NotFound',
    component: Page404
  },
  {
    path: '/auth',
    name: 'PageAuth',
    component: PageAuth
  },
  {
    path: '/',
    component: VueLayout,
    children: [
      { path: '/', component: PageAdminMain, meta: { requiresAuth: true, roles: [] } }
    ]
  },
  {
    path: '/orders',
    component: VueLayout,
    children: [
      { path: '', component: PageOrders }
    ]
  },
  {
    path: '/regular-delivery',
    component: VueLayout,
    children: [
      { path: '', component: PageRegularDelivery }
    ]
  },
  {
    path: '/shop/:shopId',
    component: VueLayout,
    children: [
      { path: '',
        component: PageShop,
        props: (route) => ({shopId: route.params.shopId})
      }
      ]
  },
  {
    path: '/pickers',
    component: VueLayout,
    children: [
      { path: '', component: PagePickers }
    ]
  },
  {
    path: '/map',
    component: VueLayout,
    children: [
      { path: '',
        component: PageGeo,
        props: {
          isCreateMode: true
        }
      },
      {
        path: '/region/:areaId',
        component: PageGeo,
        props: (route) => ({ areaId: route.params.areaId, isCreateMode: false })
      }
    ]
  },
  {
    path: '/geo',
    component: VueLayout,
    children: [
      { path: '', component: PageLocation }
    ]
  },
  {
    path: '/area',
    component: VueLayout,
    children: [
      { path: '', component: PageLocation }
    ]
  },
  {
    path: '/create-area',
    component: VueLayout,
    children: [
      { path: '',
        component: PageArea,
        props: (route) => ({shopId: route.query.shopId, isCreateMode: true})
      }
    ]
  },
  {
    path: '/area/:areaId',
    component: VueLayout,
    children: [
      { path: '',
        component: PageArea,
        props: (route) => ({areaId: route.params.areaId, isCreateMode: false, shopId: route.query.shopId})
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authService.isAuthenticated()) {
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      })
    } else {
      //if(to.matched.some(record => record.meta.roles)){

      //}
      next()
    }
  } else {
    next()
  }
})


export default router
